'use client';

import { useRef, useEffect, type ComponentProps } from 'react';

type HlsVideoProps = Omit<ComponentProps<'video'>, 'src'> & {
  hlsSrc: string;
};

export default function HlsVideo({ hlsSrc, ...videoProps }: HlsVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !hlsSrc) return;

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = hlsSrc;
      return;
    }

    let hls: import('hls.js').default | null = null;

    import('hls.js').then(({ default: Hls }) => {
      if (!Hls.isSupported()) {
        video.src = hlsSrc;
        return;
      }

      hls = new Hls();
      hls.loadSource(hlsSrc);
      hls.attachMedia(video);
    });

    return () => {
      hls?.destroy();
    };
  }, [hlsSrc]);

  return <video ref={videoRef} {...videoProps} />;
}
